import React from 'react';
import PropTypes from 'prop-types';
import { EventEmitter } from 'events';
import { t } from '../../../../../../modules/infra/i18n';

const WalkInListButton = ({ onClick }) => {
  const handleClick = () => {
    EventEmitter.prototype.emit('open-walk-in-list-modal');
    if (onClick) {
      onClick();
    }
  };

  return (
    <button type="button" className="c-btn c-btn--medium c-btn--ghost u-ml-" onClick={handleClick}>
      {t('appointment:side_by_side.walk_in_list_button')}
    </button>
  );
};

WalkInListButton.propTypes = {
  onClick: PropTypes.func,
};

export default WalkInListButton;
